// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { ServerStatus } from "services/Server/IServerStatusService";

export class ServerStatusEnumToStringValueConverter implements IValueConverter<string, number> {
    public toView(value: number): string {
        return ServerStatus[value];
    }

    public fromView(value: string): number {
        return (<unknown>ServerStatus)[value];
    }
}
